import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import { TextInput, SwitchInput, DialogoConfirmacao } from '../..';
import { getListAllAPI } from '../../../services';
import { TIPO_CONTATO_TELEFONE } from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const optionsTipoContatos = [
  {
    label: 'Telefone',
    value: TIPO_CONTATO_TELEFONE,
  },
];

const DEFAULT_ID = -1;

const DialogoCategoriaTransacao = forwardRef(
  ({ handleClose, handleSave, fornecedorId }, ref) => {
    const [open, setOpen] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [id, setId] = useState(DEFAULT_ID);
    const [nome, setNome] = useState('');
    const [temAgendamentoCompra, setTemAgendamentoCompra] = useState(true);
    const refDialogoConfirmacaoReativar = useRef(null);

    const classes = useStyles({ cor: '#009FD4' });

    const handleCloseDialog = () => {
      setOpen(false);
      handleClose();
    };

    async function reiniciar() {
      setId(DEFAULT_ID);
      setNome('');
      setTemAgendamentoCompra(true);
      setOpen(true);
    }

    function finalizarSalvar(idIndicadorChangeOverride) {
      handleSave(id, nome, temAgendamentoCompra, idIndicadorChangeOverride);
      enqueueSnackbar(
        id <= 0
          ? 'Pasta registrada com sucesso!'
          : 'Pasta editada com sucesso!',
        { variant: 'success' },
      );
      handleCloseDialog();
    }

    async function buscarPastaInativaComMesmoNome() {
      if (!fornecedorId || fornecedorId <= 0) return null;

      const data = await getListAllAPI(
        'pastas-fornecedores',
        ['id', 'asc'],
        { fornecedor_id: fornecedorId, ativo: false },
        [],
      );

      const nomeChave = nome.trim().toLowerCase();

      return (
        data.data.find(
          (pasta) => pasta.nome.trim().toLowerCase() === nomeChave,
        ) || null
      );
    }

    async function handleSalvar() {
      try {
        const pastaInativaEncontrada = await buscarPastaInativaComMesmoNome();

        if (pastaInativaEncontrada) {
          refDialogoConfirmacaoReativar.current.handleOpen(
            'Reativar Pasta',
            `Já existe uma pasta inativa chamada "${pastaInativaEncontrada.nome}" para este fornecedor. Deseja reativá-la em vez de criar uma nova?`,
            pastaInativaEncontrada.id,
          );
          return;
        }

        finalizarSalvar();
      } catch (erros) {
        enqueueSnackbar(`${erros}`, {
          variant: 'error',
        });
        handleCloseDialog();
      }
    }

    useImperativeHandle(ref, () => ({
      handleCreate() {
        reiniciar();
        setOpen(true);
      },
      handleEdit(id, nome, temAgendamentoCompra = true) {
        setId(id);
        setNome(nome);
        setTemAgendamentoCompra(temAgendamentoCompra);
        setOpen(true);
      },
    }));

    function validateNome() {
      let error = '';
      if (!nome) {
        error = 'Este campo é obrigatório';
      } else if (nome.length < 5) {
        error = 'Número de caracteres tem que ser maior ou igual a 5';
      } else if (nome.length > 300) {
        error = 'Número de caracteres tem que ser menor ou igual a 300';
      }

      return error;
    }

    function getErros() {
      const errosOld = [''];
      errosOld[0] = validateNome();
      return errosOld;
    }

    const erros = getErros();

    function hasError() {
      for (let i = 0; i < erros.length; i += 1) {
        if (erros[i] !== '') return true;
      }
      return false;
    }

    const erroExistente = hasError();

    return (
      <div>
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          classes={{ paper: classes.rootDialogo }}
          className={classes.rootDialogo}
          fullWidth
          maxWidth="sm"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle
            id="form-dialog-title"
            onClose={handleCloseDialog}
            style={{ backgroundColor: '#009FD4', color: 'white' }}
          >
            {id < 0 ? 'Nova Pasta' : 'Editar Pasta'}
          </DialogTitle>
          <DialogContent
            style={{
              padding: '10px 36px 20px',
              margin: '0',
            }}
          >
            <div>
              <Box flex={1} mr="0.5em" mt="20px">
                <TextInput
                  name="nome"
                  handleEnter={() => {}}
                  label="Nome da Pasta"
                  handleKey={() => {}}
                  value={nome}
                  onChange={(value) => setNome(value.target.value)}
                  error={erros[0] !== ''}
                  helperText={erros[0]}
                  fullWidth
                  autoFocus
                  autoCompleteState="new-password"
                />
              </Box>
              <Box flex={1} mr="0.5em" mt="10px">
                <SwitchInput
                  name="tem_agendamento_compra"
                  handleEnter={() => {}}
                  label="Gerar Agendamento de Compra para esta Pasta?"
                  handleKey={() => {}}
                  checked={temAgendamentoCompra}
                  onChange={(value) =>
                    setTemAgendamentoCompra(value.target.checked)
                  }
                  fullWidth
                />
              </Box>
            </div>
          </DialogContent>
          <DialogActions
            style={{
              padding: '0px 36px 20px',
              margin: '0',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Button
              onClick={handleCloseDialog}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              variant="contained"
              color="primary"
            >
              Fechar
            </Button>
            <div className={classes.wrapper}>
              <Button
                onClick={handleSalvar}
                classes={{
                  root: classes.btnAtions,
                  disabled: classes.btnAtionsDisabled,
                }}
                disabled={erroExistente}
                variant="contained"
                color="primary"
              >
                Salvar
              </Button>
            </div>
          </DialogActions>
        </Dialog>
        <DialogoConfirmacao
          ref={refDialogoConfirmacaoReativar}
          handleConfirma={(idPastaInativa) => finalizarSalvar(idPastaInativa)}
          handleRejeita={() => finalizarSalvar()}
        />
      </div>
    );
  },
);

export default DialogoCategoriaTransacao;
